
/*******************************************************************************
 * Copyright (c) 2019. keni
 *
 * This file TicketsAnimation.js is part of event_pass_client.dev.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential
 * TicketsAnimation.js can not be copied and/or distributed
 * without the express permission of keni
 ******************************************************************************/

export default {
    data(){
        return {}
    },
    methods:{
        animateToTargetEvent(targetId,toCloneId){
            let self = this,
                transition = 200,
                cloningElementId = `${toCloneId}`,
                elementToClone = document.getElementById(cloningElementId),

                /**
                 * @param clone.widget
                 * @param {Object} clone.style
                 * @param clone.id
                 * @type {Node} clone
                 */
                clone = elementToClone.cloneNode(true);

            elementToClone.style.position = 'relative';
            let clonedElementId = cloningElementId + '--clone';;

            clone.id = clonedElementId;
            clone.style.position = 'absolute';
            clone.style.zIndex = 9999999999;
            clone.style.opacity = 0.5;
            clone.widget = elementToClone.width;
            clone.style.transition = `transform ${transition}ms  ease-out, opacity ${transition}ms  cubic-bezier(0.95, 0.05, 0.795, 0.035)`;

            let elementToPlaceCloneBy = document.getElementById(cloningElementId);
            elementToPlaceCloneBy.appendChild(clone);

            let targetElement = document.getElementById(targetId),
                bodyRect = document.body.getBoundingClientRect(),
                elementRect = elementToClone.getBoundingClientRect(),
                cloneTopPosition = elementRect.top - bodyRect.top,
                relativeTop = cloneTopPosition - self.offset(targetElement).top;

            // elementToClone.style.opacity = 0;

            clone.style.opacity = 0;
            clone.style.transform = `translate(0px,${relativeTop * -1}px)`;
            setTimeout(function(){
                clone.parentNode.removeChild(clone);
            },transition)
        },
        animDelay(t, v) {
            return new Promise(function (resolve) {
                setTimeout(resolve.bind(null, v), t)
            });
        },

        offset(el) {
            let rect = el.getBoundingClientRect(),
                scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            return {top: rect.top + scrollTop}
        }
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/components/tickets/TicketsAnimation.js